import React from 'react';
import { bool, node, string, func } from 'prop-types';
import cx from 'classnames';

import styles from './InlineButton.scss';

export default function InlineButton({ children, className, onClick, label, showLabel }) {
  return (
    <button className={cx(styles.main, className)} onClick={onClick}>
      <div className={styles.layout}>
        <div className={styles.icon}>
          {children}
        </div>
        {/* We can hide the label to improve accessability (in case when we only show an icon for example) */}
        <div
          className={cx(styles.label, {
            [styles.hiddenLabel]: !showLabel,
          })}
        >
          {label}
        </div>
      </div>
    </button>
  );
}

InlineButton.propTypes = {
  children: node,
  className: string,
  onClick: func.isRequired,
  label: string,
  showLabel: bool,
};



// WEBPACK FOOTER //
// ./src/components/InlineButton/index.js